export default __webpack_public_path__ + "static/media/photo--lg--tom.85c3da15.jpg";